<template lang="html">
    <div class="view-home">
        <div class="block-company">
            <div class="block-company-content">
                <div class="block-company-gradient"></div>
                <div class="block-company-text">
                    <div v-if="userSite">
                        <h1>{{ userSite.facility_name }}</h1>
                        <h2>{{ userSite.company_name }}</h2>
                    </div>
                    <div v-else>
                        <h1>Sélection du site</h1>
                        Veuillez choisir le site auquel vous voulez vous connecter
                    </div>
                </div>
            </div>
        </div>
        <div class="layout-width padding" v-if="!userSite">
            <el-row>
                <el-col
                    :xs="24"
                    :sm="24"
                >
                    <el-button
                        v-if="userIsAtLeastManager"
                        style="font-size: 20px;"
                        type="primary"
                        class="btn-edit"
                        icon="el-icon-plus"
                        @click="createSite"
                    >
                        Créer un nouveau site
                    </el-button>
                    <br>
                    <br>
                    <br>
                </el-col>

                <div v-if="userRelatedSites.length===0">
                    <h3>Vous n'avez aucun site</h3>
                </div>

                <div v-if="customerSite.length > 0">
                    <h3>Sélectionner un site</h3>
                    <div v-if="userIsAtLeastManager">
                        <br>Sites en tant que client
                    </div>
                    <el-input v-model="search" placeholder="Rechercher" class="input-search"></el-input>
                    <div v-for="(_site, index) in filteredCustomerList" :key="index" class="choose-list">
                        <el-button type="text" @click="setSite(_site)" class="facility-name-btn"><b>{{_site.facility_name}}</b></el-button>
                    </div>
                </div>
                <div v-if="userIsAtLeastManager && salesmanSite.length > 0">
                    <br>
                    Sélectionnez un site
                    <el-input v-model="search" placeholder="Rechercher" class="input-search"></el-input>
                    <div v-for="(_site, index) in filteredSalesList" :key="index" class="choose-list">
                        <el-button type="text" @click="setSite(_site)" class="facility-name-btn"><b>{{_site.facility_name}}</b></el-button>

                    </div>
                </div>
            </el-row>
        </div>
            <!-- <NavBar /> -->
        <div v-else class="layout-width padding">
            <el-row>

                <el-col
                    :xs="12"
                    :sm="12"
                >
                    <el-button
                        v-if="userRelatedSites.length > 1 || userIsAtLeastManager"
                        style="font-size: 1em;"
                        class="btn-edit"
                        type="text"
                        icon="el-icon-arrow-left"
                        @click="unsetSite"
                    >
                        Sélectionner un autre site
                    </el-button>
                </el-col>
                <el-col
                    :xs="12"
                    :sm="12"
                >
                    <el-button
                        v-if="userRelatedSites.length > 1 || userIsAtLeastManager"
                        style="font-size: 1em; margin-left: auto; display: block;"
                        class="btn-edit"
                        type="text"
                        @click="archiveSite"
                    >
                        Supprimer ce site
                        <i class="el-icon-delete icon"></i>
                    </el-button>
                </el-col>
            </el-row>

            <el-row
                :gutter="20">
                <el-col
                    :xs="24"
                    :sm="12">
                    <HomeTile
                        title="Mon site"
                        subtitle="informations du site"
                        icon="industry"
                        route="Site">
                    </HomeTile>
                </el-col>
                <el-col
                    :xs="24"
                    :sm="12">
                    <HomeTile
                        :info="infoMotors"
                        title="Mes moteurs"
                        subtitle="on rentre les moteurs 1 par 1"
                        icon="cogs"
                        route="Motors">
                    </HomeTile>
                </el-col>

                <div v-if="userAudit">
                    <el-col
                        :xs="24"
                        :sm="24">
                        <HomeTile
                            :info="infoSelection"
                            title="Ma sélection"
                            subtitle="ma liste de moteurs à auditer"
                            icon="clipboard-list"
                            route="Selection"
                            :routeParams="{auditUid: userAudit.uid}"
                        >
                        </HomeTile>
                    </el-col>

                    <div class="home-subnav">
                        <el-tooltip
                            content="Veuillez sélectionné un ou plusieurs moteurs"
                            placement="left"
                            effect="dark"
                            :disabled="selectedMotors.length > 0"
                        >
                            <span class="el-button el-button--text btn-download-motor-file">
                                <el-button
                                    type="primary"
                                    class=""
                                    :disabled="selectedMotors.length === 0"
                                    @click="requestMotorSelecedFile"
                                >télécharger ma sélection</el-button>
                            </span>
                        </el-tooltip>
                    </div>
                </div>
                <div v-else >

                    <el-col><br></el-col>
                    <el-col><br></el-col>
                    <el-col><br></el-col>
                    <el-col :xs="24" :sm="18">
                        <i>Vous n'avez aucun audit pour ce site</i>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-button
                            style="font-size: 1em;"
                            class="btn-edit"
                            type="primary"
                            icon="el-icon-plus"
                            @click="createNewAudit"
                        >
                            Ajouter un audit
                        </el-button>
                    </el-col>
                </div>
            </el-row>
        </div>

        <div class="layout-width">
            <div class="home-subnav">
                <br>
                <router-link
                    :to="{ name: 'Help' }">
                    <el-button
                        round
                        icon="el-icon-info">
                        Comment ça marche ?
                    </el-button>
                </router-link>
            </div>
        </div>
        <waiting-modal
            ref="waiting-modal"
            loading-text="Generating file"
            :onSuccess="downloadFile"
        ></waiting-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import NavBar from '@/components/ui/NavBar';
import HomeTile from './HomeTile';
import WaitingModal from '../../partials/WaitingModal';
import schwartz from 'schwartz';


export default {
    name: 'Home',
    components: {
        // NavBar,
        HomeTile,
        WaitingModal,
    },
    data (){
        return {
            verboseStatus: {
                'VALIDATED': 'VALIDÉ',
                'PREPARED': 'PRÉPARÉ',
                'SHIPPED': 'EXPÉDIÉ',
                'AUDITED': 'AUDITÉ',
                'RECEIVED': 'REÇU',
                'PENDING': 'EN ATTENTE',
            },
            siteForm: {
                facility_name: '',
                company_name: '',
            },
            auditForm: {
                name: '',
                motorbox_count: 0,
                date: '',
            },
            search: '',
        };
    },
    computed: {
        ...mapGetters([
            'audit',
            'currentSite',
            'siteRelatedMotors',
            'site',
            'auditByUid',
            'userByUid',
            'currentUser',
            'getFormattedAuditDate',
            'userIsAtLeastManager',
            'auditSelectedMotorsUids'
        ]),
        salesmanSite() {
            return this.site.filter(s => s.salesperson_uid === this.currentUser.uid)
        },
        customerSite() {
            return this.site.filter(s => s.customer_uid === this.currentUser.uid)
        },
        userRelatedSites() {
            return this.salesmanSite.concat(this.customerSite)
        },
        userSite () {
            if (this.currentSite){
                return this.currentSite;
            }
            // if (this.userRelatedSites.length === 1){
            //     this.$store.commit('SET_CURRENT_SITE', this.userRelatedSites[0])
            //     return this.userRelatedSites[0]
            // }
            if (!this.userIsAtLeastManager){
                if (this.customerSite.length === 1){
                    this.$store.commit('SET_CURRENT_SITE', this.customerSite[0])
                    return this.customerSite[0]
                }
                else if(this.customerSite.length === 0){
                    this.$notify.error({
                        title: 'Erreur',
                        message: 'Aucun site n\'est lié à votre compte. Veuillez contacter un administrateur',
                        duration: 0,
                    })
                }
            }
        },
        userAudit() {
            if (this.userSite){
                let audits = this.audit.filter(a => a.site_uid === this.userSite.uid)
                if (audits.length > 0){
                    return audits[0]
                }
            }
        },
        availableAudits() {
            let audits = this.audit.filter(a => a.user_uid === this.userSite.customer_uid)
            // let audits = this.audit.filter(a => a.site_uid === this.userSite.uid)
            return audits
        },
        infoMotors () {
            const plural = this.siteRelatedMotors.length > 1 ? 's' : '';
            return this.siteRelatedMotors.length ? this.siteRelatedMotors.length + ' moteur' + plural + ' enregistré' + plural : 'Aucun moteur enregistré';
        },
        infoSite () {
            const plural = this.availableAudits.length > 1 ? 's' : '';
            return this.availableAudits.length ? this.availableAudits.length + ' audit' + plural  : 'Aucun audit';
        },
        selectedMotors (){
            let selectedMotorsUids = this.auditSelectedMotorsUids(this.userAudit)
            return this.siteRelatedMotors.filter(m => selectedMotorsUids.includes(m.uid));
        },
        infoSelection () {
            const selectionLength = this.selectedMotors.length;
            const plural = selectionLength > 1 ? 's' : '';
            return selectionLength ? selectionLength + ' moteur' + plural + ' sélectionné' + plural : 'Aucun moteur sélectionné';
        },
        filteredSalesList() {
            let sales = this.salesmanSite.filter(salesmanSite => {
                if (salesmanSite && salesmanSite.facility_name)
                    return salesmanSite.facility_name.toLowerCase().includes(this.search.toLowerCase());
                else {
                    return false;
                }
            })
            return schwartz(sales, sale => {
                return sale.facility_name.toLowerCase()

            });
        },

        filteredCustomerList() {
            let customers = this.customerSite.filter(customerSite => {
                if (customerSite && customerSite.facility_name)
                    return customerSite.facility_name.toLowerCase().includes(this.search.toLowerCase());
                else {
                    return false;
                }
            })
            return schwartz(customers, customer => {
                return customer.facility_name.toLowerCase()
            });
        }

    },
    methods: {
        requestMotorSelecedFile (){
            var site = this.userSite ? this.userSite : this.site[0]
            this.$refs['waiting-modal'].open();
            this.$store.dispatch('createItem', {
                item: {
                    motors_uid: this.siteRelatedMotors.map((motor) => motor.uid),
                    selected_motors_uid: this.auditSelectedMotorsUids(this.userAudit),
                    status: 'PENDING',
                    site_uid: site.uid,
                    platform_type: 'autonome'
                },
                model: 'generateFileRequest',
                url: this.$store.state.api.meta.listModels.generateFileRequest.url,
            }).then((res) => {
                this.$refs['waiting-modal'].watchRequestStatus(res.url);
            }).catch((e) => {
                this.$refs['waiting-modal'].displayError();
            },)
        },
        createNewAudit(){
            this.$router.push({name: 'Audit'});
        },
        downloadFile (response) {
            var element = document.createElement('a');
            element.setAttribute('href', response.data.xlsx_file);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        setSite(site){
            this.$store.commit('SET_CURRENT_SITE', site)
        },
        unsetSite(){
            this.$store.commit('UNSET_CURRENT_SITE')
        },
        createSite(){
            this.unsetSite()
            this.$router.push({name: 'Site'})
        },
        archiveSite(){
            this.$confirm('Voulez-vous vraiment supprimer ce site ?',{
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler',
                })
            .then(() =>{
                var site = this.userSite ? this.userSite : this.site[0]
                this.$store.dispatch('patchItem', {
                    item: {
                        is_archived: true,
                        url: site.url,
                    },
                    model: 'site',
                    url: this.$store.state.api.meta.listModels.site.url,
                })
                .then(response => {
                    this.$store.dispatch(
                        'reloadModels',
                        {site}
                    ).then(response => {
                        this.unsetSite();
                        this.$notify({
                          title: 'Supprimé',
                          message: 'Le site a été supprimé',
                          type: 'success',
                          duration: 3000,
                        });
                    })
                })
                .catch(error => {
                    this.$notify({
                      title: 'Erreur',
                      message: "Le site n'a pas pu être supprimé",
                      type: 'success',
                      duration: 3000,
                    });
                })
            }).catch(() => {
                return;
            })         
        }
    },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';

.block-company {
    position: relative;
    background: $--color-primary;
    background: url('../../../../static/images/shounen21-778549-unsplash.jpg') no-repeat center center;
    background-size: cover;
    color: white;
    h1 {
        font-size: 40px;
        line-height: 40px;
        margin-bottom: 0;
    }
    h2 {
        font-size: 20px;
        line-height: 20px;
        text-transform: uppercase;
    }
    .block-company-text {
        display: block;
        position: relative;
        max-width: $layout-width;
        margin: auto;
        padding: 0 20px;
    }
    .block-company-content {
        display: block;
        position: relative;
        padding: 80px 0 20px;
    }
    .block-company-gradient {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(to bottom, rgba(#000,0) 0%,rgba(#000,0.3) 100%);
    }
}

.price-box {
    h3 {
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        padding: 20px 0 30px;
        .mwh-unit {
            font-size: 12px;
            vertical-align: super;
        }
    }
}

.description-list {
    margin: 0;
    dt {
        font-size: 12px;
        color: #ccc;
    }
    dd {
        margin: 0;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    a {
        color: $--color-primary;
    }
}

.view-home {
    .home-subnav {
        padding: 20px;
        padding-top: 0;
        .el-tooltip.el-button.el-button--text{
            padding: 0;
        }
    }
    .btn-download-motor-file{
        margin-bottom: 30px;
    }
}
.choose-list{
    margin-left: 4em;
}
.input-search {
    margin-top: 1em;
    margin-bottom: 1em;
}
.facility-name-btn {
    border: 1px solid;
    padding-left: 1em;
    padding-right: 1em;
    margin-bottom: 1em;
}
.icon {
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/AutonomeHome.vue